import { call, put, takeLatest } from "redux-saga/effects";
import { ManagerContactReportAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as contactReportApi from "../../api/contactReport/managerContactReport";
import { GetFilter } from "../../containers/contactReports/filter/tools";
import { SetMessage } from "../../assets/errorMessages";

export function* managerWatcherContactReport() {
  yield takeLatest(types.MANAGER_GET_CONTACT_SUMMARY_REQUEST, worker);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return contactReportApi.getSummaryList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerContactReportAction.getSummarySuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerContactReportAction.getSummaryFailure(message));
  }
}
